import { zodContractsDetailsListResponseSchema } from '../validations';

export { zodContractSchema } from '../validations';

export const zodContractsBulkResponseSchema =
  zodContractsDetailsListResponseSchema;
